export default function Shop() {
  return <div className="p-6 text-center text-xl">Shop Page</div>;
}